import styles from './index.css'
import * as preact from 'preact'

const { h, Component } = preact

export const Share = () => {
    return (
        <div className={`nrkno-share nrkno-no-print ${styles['sharewrapper']}`} data-share-url="https://www.nrk.no/stille-i-stormen-1.14264682">
            <a class="nrk-button nrk-button--o" data-share="Article:Facebook" rel="noopener" target="_blank" href="https://www.facebook.com/sharer.php?u=https%3A%2F%2Fwww.nrk.no%2Fstille-i-stormen-1.14264682">
                <span class="nrk-sr">Del på Facebook</span>
                <svg viewBox="0 0 15 15">
                    <title>Del på Facebook</title>
                    <path d="M8.4 4.6c0-.5 0-.8.8-.8h1V2H8.7C7 2 6.2 3.2 6.2 4.6v1H4.7v2h1.5V13h2.2V7.5H10l.2-1.8H8.4v-1z" />
                </svg>
            </a>
            <a class="nrk-button nrk-button--o" data-share="Article:Twitter" rel="noopener" target="_blank" href="https://twitter.com/intent/tweet?url=https%3A%2F%2Fwww.nrk.no%2Fstille-i-stormen-1.14264682&amp;text=Stille%20i%20Stormen">
                <span class="nrk-sr">Del på Twitter</span>
                <svg viewBox="0 0 15 15">
                    <title>Del på Twitter</title>
                    <path d="M14 4c-.4.3-1 .4-1.4.5.5-.3 1-.8 1-1.3-.4.3-1 .4-1.5.6-.3-.5-1-.8-1.7-.8C9 3 7.8 4 7.8 5.4V6C6 5.7 4 5 3 3.3l-.3 1.2c0 1 .4 1.6 1 2-.3 0-.7 0-1-.3 0 1.2.8 2.2 2 2.4h-.7-.5c.4 1 1.3 1.7 2.3 1.7-.8.6-2 1-3 1H2c1 .7 2.4 1 3.8 1 4.5 0 7-3.6 7-6.7v-.3c.5-.4 1-.8 1.2-1.3" />
                </svg>
            </a>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/v1/components/Footer/Share/index.tsx